// JournalConfig Actions
export const SET_JOURNAL_CONFIG = "SET_JOURNAL_CONFIG";

export function setJournalConfig(config) {
    return {
        type: SET_JOURNAL_CONFIG,
        payload: config
    }
}
